import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import Box from "../../../../components/Box";
import { Helpers } from "../../../../helpers/Helpers";
import { GetYurticiCargoListResponseData, GetYurticiCargoListResponseYurticiCargoExpectedIncomeOutcome } from "../../../../models/response/yurticiCargo/GetYurticiCargoListResponse";

interface Props {
    findPrice: () => Promise<void>
    data: GetYurticiCargoListResponseData[]
    setData: React.Dispatch<React.SetStateAction<GetYurticiCargoListResponseData[]>>
}

const Orders = ({
    findPrice,
    data,
    setData
}: Props) => {
    const getExpectedIncomeOutcomeText = (type: string, list: GetYurticiCargoListResponseYurticiCargoExpectedIncomeOutcome[]) => {
        var totalCount = list.length;

        if (totalCount == 0)
            return "Beklenen " + type + " Yok";

        var invoicedCount = list.filter(x => x.invoiceNo && !Helpers.isEmpty(x.invoiceNo)).length;
        var notInvoicedCount = totalCount - invoicedCount;

        if (totalCount == invoicedCount)
            return "Faturalandı";
        else if (invoicedCount == 0)
            return "Faturalanmadı";
        else
            return "Kısmi Faturalandı";
    }

    const setItemSelected = (_id: string) => {
        setData(data.map(function (x) {
            if (x.yurticiCargoId == _id)
                x.isSelected = !x.isSelected;

            return x;
        }));
    }

    const selectAll = () => {
        var isAllSelected = data.filter(x => x.companyId).length == data.filter(x => x.companyId && x.isSelected).length;

        setData(data.map(function (x) {
            if (x.companyId)
                x.isSelected = !isAllSelected;

            return x;
        }));
    }

    return (
        <KTCard className="ebbe-card mt-10">
            <KTCardBody>
                <h4 className="mb-10 text-black">Siparişler</h4>

                <Box flexDirection="row">
                    <Box onClick={findPrice} className={"actionIcon p-2"} bg="orange" opacity={"1"} justifyContent="center" flexDirection="row" borderRadius="4px">
                        <Box mr="5px" justifyContent="center">
                            <i className={"text-white fa fa-search"} />
                        </Box>
                        <Box justifyContent="center">
                            <span style={{ fontWeight: 600 }} className="text-white">{'Bul'}</span>
                        </Box>
                    </Box>
                </Box>

                <div className="row mt-5">
                    <div className="col-md-12">
                        <div className='table-responsive'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.filter(x => x.isSelected).length > 0 && data.filter(x => x.isSelected).length == data.length} />
                                                </label>
                                            </div>
                                        </th>
                                        <th>Ref No</th>
                                        <th>Beklenen Gelir Fatura Durumu</th>
                                        <th>Toplam Beklenen Gelir</th>
                                        <th>Toplam Brüt Beklenen Gelir</th>
                                        <th>Beklenen Gider Fatura Durumu</th>
                                        <th>Toplam Beklenen Gider</th>
                                        <th>Toplam Brüt Beklenen Gider</th>
                                        <th>Sipariş Tarihi</th>
                                        <th>Gönderi Kodu</th>
                                        <th>Müşteri</th>
                                        <th>Bölüm</th>
                                        <th>Po</th>
                                        <th>Po Number</th>
                                        <th>Sipariş Durumu</th>
                                    </tr>
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.map((item, index) =>
                                            <tr>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.yurticiCargoId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>{item.refNo}</td>
                                                <td>{getExpectedIncomeOutcomeText("Gelir", item.yurticiCargoExpectedIncomeOutcomes.filter(x => x.isIncome))}</td>
                                                <td className="custom-text-right">{Helpers.correctPrice(Helpers.sumOfNumbers(item.yurticiCargoExpectedIncomeOutcomes.filter(x => x.isIncome).map(x => x.totalWithoutTaxPrice ?? 0)))}</td>
                                                <td className="custom-text-right">{Helpers.correctPrice(Helpers.sumOfNumbers(item.yurticiCargoExpectedIncomeOutcomes.filter(x => x.isIncome).map(x => x.totalPrice ?? 0)))}</td>
                                                <td>{getExpectedIncomeOutcomeText("Gider", item.yurticiCargoExpectedIncomeOutcomes.filter(x => !x.isIncome))}</td>
                                                <td className="custom-text-right">{Helpers.correctPrice(Helpers.sumOfNumbers(item.yurticiCargoExpectedIncomeOutcomes.filter(x => !x.isIncome).map(x => x.totalWithoutTaxPrice ?? 0)))}</td>
                                                <td className="custom-text-right">{Helpers.correctPrice(Helpers.sumOfNumbers(item.yurticiCargoExpectedIncomeOutcomes.filter(x => !x.isIncome).map(x => x.totalPrice ?? 0)))}</td>
                                                <td>{item.shippingCreateDateStr}</td>
                                                <td>{item.shippingCode}</td>
                                                <td>{item.customerName}</td>
                                                <td>{item.divisionName}</td>
                                                <td>{item.poName}</td>
                                                <td>{item.poNo}</td>
                                                <td>{item.shippingStatusName}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default Orders;